import TabbedSilo from "@/components/TabbedSilo";

export default function MortgageNotes() {
  return (
    <TabbedSilo
      eyebrow="Portfolio · Mortgage Notes"
      title="Mortgage Notes"
      subtitle="Seller-financed first and second mortgages held as receivables."
      assetType="note_receivable"
      mode="notes"
    />
  );
}
